import { getProductById } from '@shared/products';
import astralMap from '../../assets/astral-map.jpg';
import tikkunMap from '../../assets/tikkun-map.jpg';

type ProductImageProps = {
    productId?: string | null;
}

export default function ProductImage({ productId }: ProductImageProps) {

    if (!productId) return null;

    const product = getProductById(productId);


    return (
        <div className='flex flex-col items-center mx-auto'>
            <img src={productId === 'astral' ? astralMap : tikkunMap} alt={product.displayName} className='mx-auto h-full rounded-full overflow-hidden' />
        </div>
    )
}